<div
  class="outer_container_footer_lp"
  [ngClass]="{ greyBackground: greyBackground() }"
>
  <div class="footer_container max_width_page_component">
    <footer class="footer">
      <div class="inner_content_footer">
        <div class="footer-elements">
          <div class="footer-desc">
            <p class="pinploy_comp_desc">
              {{ 'PAGES.LANDING.FOOTER_DESC' | translate }}
              <br /><br />
              {{ 'PAGES.LANDING.FOOTER_SLOGAN' | translate }}
            </p>
          </div>

          <nav class="footer_navigation_items">
            <div class="fotter_navigation">
              <div
                class="footer_header"
                [class.footer_header--mobile]="isMobile()"
                (click)="toggleSection('company')"
              >
                <p>{{ 'PAGES.LANDING.FOOTER_COMPANY' | translate }}</p>
                @if (isMobile()) {
                  <mat-icon
                    class="footer_chevron"
                    [class.expanded]="isSectionExpanded('company')"
                    >chevron_right</mat-icon
                  >
                }
              </div>
              @if (isSectionExpanded('company')) {
                <div class="footer_links">
                  @for (link of companyLinks(); track $index) {
                    <a [href]="link.route" class="footer_sub">
                      {{ link.labelKey | translate }}
                    </a>
                  }
                </div>
              }
            </div>
          </nav>

          <nav class="footer_navigation_items">
            <div class="fotter_navigation">
              <div
                class="footer_header"
                [class.footer_header--mobile]="isMobile()"
                (click)="toggleSection('explore')"
              >
                <p>{{ 'PAGES.LANDING.FOOTER_EXPLORE' | translate }}</p>
                @if (isMobile()) {
                  <mat-icon
                    class="footer_chevron"
                    [class.expanded]="isSectionExpanded('explore')"
                    >chevron_right</mat-icon
                  >
                }
              </div>
              @if (isSectionExpanded('explore')) {
                <div class="footer_links">
                  @for (link of footerLinks(); track $index) {
                    <a [href]="link.route" class="footer_sub">
                      @if (link.label) {
                        {{ link.label }}
                      } @else if (link.labelKey) {
                        {{ link.labelKey | translate }}
                      }
                    </a>
                  }
                </div>
              }
            </div>
          </nav>

          <nav class="footer_navigation_items">
            <div class="fotter_navigation">
              <div
                class="footer_header"
                [class.footer_header--mobile]="isMobile()"
                (click)="toggleSection('categories')"
              >
                <p>{{ 'PAGES.LANDING.POPULAR_CATEGORIES' | translate }}</p>
                @if (isMobile()) {
                  <mat-icon
                    class="footer_chevron"
                    [class.expanded]="isSectionExpanded('categories')"
                    >chevron_right</mat-icon
                  >
                }
              </div>
              @if (isSectionExpanded('categories')) {
                <div class="footer_links">
                  @for (link of headCategoryLinks(); track $index) {
                    <a [href]="link.url" class="footer_sub">
                      {{ link.category }}
                    </a>
                  }
                </div>
              }
            </div>
          </nav>
        </div>

        <div class="badge_img_container">
          <!-- #Google play badges -->
          <a
            [href]="appStore.android"
            rel="nofollow"
            style="font-size: 0"
            (click)="clickOutToAppStore()"
          >
            <img
              alt="Handyhand google app download"
              class="google top_badge"
              [ngSrc]="appStoreAndroidIcon()"
              width="207"
              height="80"
              style="height: auto"
            />Google play store
          </a>

          <!-- #Apple appstore badges -->
          <a
            [href]="appStore.ios"
            rel="nofollow"
            style="font-size: 0"
            (click)="clickOutToAppStore()"
          >
            <img
              alt="Handyhand Apple download app"
              class="apple"
              [ngSrc]="appStoreIosIcon()"
              width="160"
              height="53"
              style="height: auto"
            />App store
          </a>
        </div>
        <div class="social_media">
          <svg
            class="social-icon"
            (click)="open('facebook')"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.3352 3.66477C19.0625 1.39205 15.9375 0 12.5 0C9.0625 0 5.9375 1.39205 3.66477 3.66477C1.39205 5.90909 0 9.03409 0 12.5C0 19.4034 5.59659 25 12.5 25C15.9375 25 19.0625 23.608 21.3352 21.3352C23.608 19.0625 25 15.9375 25 12.5C25 9.03409 23.5795 5.90909 21.3352 3.66477ZM15.9659 7.58523C15.9659 7.58523 14.8011 7.58523 14.3182 7.58523C13.75 7.58523 13.608 7.8125 13.608 8.4375C13.608 8.94886 13.608 9.88636 13.608 9.88636H15.9659L15.7386 12.4432H13.608V20.0568H10.5966V12.4716H9.00568V9.88636H10.5966C10.5966 9.88636 10.5966 9.51705 10.5966 7.84091C10.5966 5.9375 11.6193 4.94318 13.8636 4.94318C14.233 4.94318 15.9659 4.94318 15.9659 4.94318V7.58523Z"
              fill="#A1A2B1"
            />
          </svg>
          <svg
            class="social-icon"
            (click)="open('instagram')"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5002 10.1992C11.2502 10.1992 10.2275 11.2219 10.2275 12.4719C10.2275 13.7219 11.2502 14.7446 12.5002 14.7446C13.7502 14.7446 14.7729 13.7219 14.7729 12.4719C14.8013 11.2219 13.7786 10.1992 12.5002 10.1992Z"
              fill="#A1A2B1"
            />
            <path
              d="M17.8409 8.43799C17.7272 8.12549 17.5568 7.89822 17.3295 7.64253C17.0738 7.41526 16.875 7.24481 16.5341 7.13117C16.3068 7.04594 15.9375 6.93231 15.2557 6.9039C14.5454 6.87549 14.3182 6.87549 12.5 6.87549C10.6818 6.87549 10.4545 6.87549 9.74429 6.9039C9.06247 6.93231 8.72156 7.04594 8.46588 7.13117C8.15338 7.24481 7.92611 7.41526 7.67043 7.64253C7.41474 7.89822 7.2727 8.09708 7.15907 8.43799C7.07384 8.69367 6.9602 9.03458 6.93179 9.7164C6.90338 10.4266 6.90338 10.6539 6.90338 12.4721C6.90338 14.2903 6.90338 14.5175 6.93179 15.2278C6.9602 15.9096 7.07384 16.2505 7.15907 16.5062C7.2727 16.8187 7.44315 17.0459 7.67043 17.3016C7.8977 17.5573 8.12497 17.6994 8.46588 17.813C8.72156 17.8982 9.06247 18.0119 9.74429 18.0403C10.4545 18.0687 10.6818 18.0687 12.5 18.0687C14.3182 18.0687 14.5454 18.0687 15.2557 18.0403C15.9375 18.0119 16.2784 17.8982 16.5341 17.813C16.8466 17.6994 17.0738 17.5289 17.3295 17.3016C17.5568 17.0744 17.7272 16.8471 17.8409 16.5062C17.9261 16.2505 18.0398 15.9096 18.0682 15.2278C18.0966 14.5175 18.0966 14.2903 18.0966 12.4721C18.0966 10.6539 18.0966 10.4266 18.0682 9.7164C18.0398 9.06299 17.9261 8.69367 17.8409 8.43799ZM12.5 15.9948C10.5682 15.9948 8.97725 14.4323 8.97725 12.4721C8.97725 10.5403 10.5397 8.94935 12.5 8.94935C14.4318 8.94935 16.0227 10.5119 16.0227 12.4721C16.0227 14.4323 14.4602 15.9948 12.5 15.9948ZM16.1648 9.65958C15.7102 9.65958 15.3409 9.29026 15.3409 8.83572C15.3409 8.38117 15.7102 8.01185 16.1648 8.01185C16.6193 8.01185 16.9886 8.38117 16.9886 8.83572C16.9886 9.29026 16.6193 9.65958 16.1648 9.65958Z"
              fill="#A1A2B1"
            />
            <path
              d="M21.3352 3.66477C19.0909 1.39205 15.9659 0 12.5 0C9.0625 0 5.9375 1.39205 3.66478 3.66477C1.39205 5.90909 0 9.03409 0 12.5C0 19.4034 5.59659 25 12.5 25C15.9375 25 19.0625 23.608 21.3352 21.3352C23.608 19.0625 25 15.9375 25 12.5C25 9.03409 23.608 5.90909 21.3352 3.66477ZM19.3182 15.3125C19.2898 16.0511 19.1761 16.5341 19.0057 16.9886C18.8352 17.4432 18.608 17.8125 18.2102 18.2102C17.8409 18.5795 17.4432 18.8352 16.9886 19.0057C16.5625 19.1761 16.0511 19.2898 15.3409 19.3182C14.6023 19.3466 14.375 19.3466 12.5284 19.3466C10.6818 19.3466 10.4261 19.3466 9.71591 19.3182C8.97728 19.2898 8.49432 19.1761 8.03977 19.0057C7.58523 18.8352 7.21591 18.608 6.81818 18.2102C6.44886 17.8409 6.19319 17.4432 6.02273 16.9886C5.85228 16.5625 5.73864 16.0511 5.71023 15.3125C5.68182 14.5739 5.68182 14.3466 5.68182 12.5C5.68182 10.625 5.68182 10.3977 5.71023 9.6875C5.73864 8.94887 5.85228 8.46591 6.02273 8.03977C6.19319 7.58523 6.42045 7.21591 6.81818 6.81818C7.1875 6.44886 7.58523 6.19318 8.03977 6.02273C8.46591 5.85227 8.97728 5.73864 9.71591 5.71023C10.4545 5.68182 10.6818 5.68182 12.5284 5.68182C14.4034 5.68182 14.6307 5.68182 15.3409 5.71023C16.0795 5.73864 16.5625 5.85227 16.9886 6.02273C17.4432 6.19318 17.8125 6.42045 18.2102 6.81818C18.5795 7.1875 18.8352 7.58523 19.0057 8.03977C19.1761 8.46591 19.2898 8.97727 19.3182 9.6875C19.3466 10.4261 19.3466 10.6534 19.3466 12.5C19.3466 14.3466 19.3466 14.5739 19.3182 15.3125Z"
              fill="#A1A2B1"
            />
          </svg>

          <svg
            class="social-icon"
            (click)="open('linkedin')"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.3352 3.66477C19.0625 1.42045 15.9659 0 12.5 0C9.0625 0 5.93751 1.39205 3.66478 3.66477C1.39205 5.9375 0 9.0625 0 12.5C0 19.4034 5.59659 25 12.5 25C15.9375 25 19.0625 23.608 21.3352 21.3352C23.608 19.0625 25 15.9659 25 12.5C25 9.0625 23.5795 5.9375 21.3352 3.66477ZM9.43182 18.0682H6.84659V9.71591H9.43182V18.0682ZM8.125 8.63636C7.27273 8.63636 6.59091 7.95454 6.59091 7.10227C6.59091 6.25 7.27273 5.56818 8.125 5.56818C8.97727 5.56818 9.65909 6.25 9.65909 7.10227C9.65909 7.92614 8.94887 8.63636 8.125 8.63636ZM19.1193 18.0682H16.5341C16.5341 18.0682 16.5341 14.8864 16.5341 13.6932C16.5341 12.5 16.0795 11.8182 15.1136 11.8182C14.0909 11.8182 13.5511 12.5284 13.5511 13.6932C13.5511 14.9716 13.5511 18.0682 13.5511 18.0682H11.0795V9.71591H13.5511V10.8523C13.5511 10.8523 14.2898 9.46023 16.0795 9.46023C17.8409 9.46023 19.1193 10.5398 19.1193 12.7841C19.1193 15.0284 19.1193 18.0682 19.1193 18.0682Z"
              fill="#A1A2B1"
            />
          </svg>
        </div>
        <div class="footer-copyright">
          <p id="copyright_p" style="color: white !important">
            {{ 'PAGES.LANDING.COPYRIGHT' | translate }}
          </p>
        </div>
      </div>
    </footer>
  </div>
</div>
